var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#send_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.187 2.306c-.556.18-.88.375-1.287.78-.681.682-.938 1.395-.881 2.407.031.506.218 1.306 1.187 5.069L2.35 15.03l5.75.03c5.6.032 5.75.032 5.956.157.332.194.475.431.475.781 0 .35-.144.588-.475.781-.206.125-.356.125-5.956.157l-5.75.031-1.144 4.469c-1.244 4.831-1.325 5.25-1.144 6.006.188.794.857 1.669 1.532 2.012.675.338 1.518.45 2.218.288.325-.075 26.032-10.719 26.594-11.012C31.413 18.204 32 17.198 32 15.998c0-1.2-.587-2.206-1.594-2.731-.562-.294-26.269-10.937-26.594-11.012-.437-.1-1.237-.075-1.625.05Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "send_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgSend;